export default "<div>\n    <app-photo-editor-tools-text></app-photo-editor-tools-text>\n</div>"